import React, { Component } from 'react';
import { TextField } from 'material-ui';

import renderHighLightText from '../../utils/text-helper';
import InfiniteLoaderList from '../InfiniteLoaderList';
import LoadingIndicator from '../LoadingIndicator';
import Icon from '../Icon';
import { S } from './styles';
import './styles.css';

class PaginatedMultiSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTerm: this.props.searchTerm,
    };
  }

  _getHighlightedText = (text) => {
    const { searchTerm } = this.state;

    return (
      <S.FilterItemText>
        <span>{text}</span>
        {renderHighLightText(text, searchTerm)}
      </S.FilterItemText>
    );
  };

  render() {
    const {
      placeholder,
      options,
      hasNextPage,
      isNextPageLoading,
      loadNextPage,
      onSearchByTerm,
      value,
      identifier,
      customItemLoadCheck,
      hasInputWithRightMargin,
      onChange,
      itemSize,
      totalOptions,
    } = this.props;
    const { searchTerm } = this.state;
    const defaultItemLoadCheck = index =>
      !hasNextPage || index < (options || []).length;
    const isItemLoaded = index =>
      (customItemLoadCheck
        ? customItemLoadCheck(index)
        : defaultItemLoadCheck(index));

    const ListItem = ({ index, style }) => {
      const itemName = options[index] ? options[index].name : '';
      const id = options[index] ? options[index].id : '';

      if (!isItemLoaded(index) && index < totalOptions) {
        return (
          <div
            style={{
              ...style,
            }}
            id={`listItem-${index}`}
          >
            <LoadingIndicator listLoader text="Carregando..." theme="dark" />
          </div>
        );
      }

      return (
        itemName.length > 0 && (
          <div
            style={{
              ...style,
              display: 'flex',
            }}
            id={`listItem-${index}`}
          >
            <S.FilterItemTextWrapper>
              {this._getHighlightedText(itemName)}
            </S.FilterItemTextWrapper>
            <input
              type="checkbox"
              checked={value.some(val => val.id === id)}
              onChange={() => {
                if (value.some(val => val.id === id)) {
                  onChange(value.filter(val => val.id !== id));
                } else {
                  onChange([...value, options[index]]);
                }
              }}
            />
          </div>
        )
      );
    };

    return (
      <div className="PaginatedMultiSelect">
        <div
          className={
            hasInputWithRightMargin
              ? 'PaginatedMultiSelect__input-wrapper PaginatedMultiSelect__input-wrapper-with-margin '
              : 'PaginatedMultiSelect__input-wrapper'
          }
        >
          <TextField
            type="text"
            id={identifier}
            value={searchTerm}
            placeholder={placeholder}
            className="PaginatedMultiSelect__input"
            autoComplete="off"
            onChange={({ target }) => {
              this.setState(
                {
                  searchTerm: target.value,
                },
                () => {
                  onSearchByTerm(target.value);
                },
              );
            }}
          />
          <Icon name="search" className="PaginatedMultiSelect__input-icon" />
        </div>
        {options && options.length > 0 ? (
          <InfiniteLoaderList
            isItemLoaded={isItemLoaded}
            hasNextPage={hasNextPage}
            isNextPageLoading={isNextPageLoading}
            options={options}
            loadNextPage={loadNextPage || null}
            itemSize={itemSize}
          >
            {ListItem}
          </InfiniteLoaderList>
        ) : (
          <LoadingIndicator listLoader text="Carregando..." theme="dark" />
        )}
      </div>
    );
  }
}

export default PaginatedMultiSelect;
